module.exports = __webpack_public_path__ + "s/img/Power_M_2.b6f6d918.jpg";